// Minimal translation hook – returns Vietnamese strings used by Footer contact form
const vi = {
  contact: {
    placeholder: {
      fullName: "Họ và tên",
      phone: "Số điện thoại",
      email: "Email",
      address: "Địa chỉ",
      content: "Nội dung",
    },
    form: {
      button: "Gửi liên hệ",
    },
  },
};

export default function useTrans() {
  return vi;
}
